<template src= "./index.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import { Tag } from 'element-ui'
import moment from 'moment'
import agTableComp from '@/optionData/agTableComp'

export default {
  name: 'artistList',
  
    data () {
        return {
            ko : ko,
            optionData : optionData,
           //급계약코드(디폴트) / Email ID / 권리자명 / 회사
            keywordOption :[
                {value: 'ref_code', label:'선급계약코드'},
                {value: 'user_email', label:'Email ID'},
                {value: 'user_name', label:'권리자명'},
                {value: 'user_company', label:'회사명'},
            ],
            keywordType :'ref_code',
            keyword : '',
          
            hideFinished: true,
            startDate :null,
            endDate : null,
            dateType :'created_at' ,
            dateOption : [
                {value: 'created_at',label: '등록일',},
                {value: 'start_date',label: '선급계약일',},
            ],
            total : 0,
            filtered:0,
            page: {
                pageSize : 10,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이플 옵션
                onRowClicked: (event)=>{
                    //this.viewDetail(event)
                },
                frameworkComponents : {
                    btnSelect : agTableComp.btnSelect,
                },
                context: {
                    componentParent: this
                },
                getRowHeight:(params)=>{
                    console.log(params)
                    return 80;
                }
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: false,
                rowSelection:'single'
            },
            
            columnDefs: [

                // album_count: 1
                // amount_remaining: 40072232.84693845
                // amount_total: 42906150
                // created_at: "2021-12-13T07:11:07.445Z"
                // end_date: null
                // id: 5
                // licensor_id: 1813
                // ref_code: "AP0005"
                // service_fee: 15
                // start_date: "2021-10-21"
                // updated_at: "2022-01-05T02:44:11.094Z"
                // user_company: "리플라이프로젝트"
                // licensor.currency: "krw"
                // user_email: "reflyproject@soundrepublica.com"
                // user_family_name: "노"
                // user_given_name: "건식"
                // user_name: "노 건식"

                {headerName: '선급계약코드', field: 'ref_code', filter: false,width: 130,
                    cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.viewDetail(data.id);
                        },
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'btnSelect',
                            params: {
                                ...data.data,
                                title: data.value
                            }
                        } ;
                        // if(this.selectTrack.track_id ==  data.data.track_id ){
                        //     dd.params['disabled'] = true
                        //     dd.params['title'] = '선택완료'
                        // }
                        
                        return dd
                    }
                },
                {headerName: '선급계약일',      field: 'start_date',     filter: false,width: 130,
                cellRenderer: (data) => {
                    return `<div class="cellCenter"><span>${this.fixDate(data.value)}</span></div>`
                }},
                
                {headerName: '상계대상',  field: 'album_count',  filter: false,width: 130,cellRenderer: (data) => {
                    let t = this.numberFilter(data.value) + ' 앨범'
                    
                    return `<div class="cellCenter"><span>${t}</span></div>`
                }},
                {headerName: '총 선급금액',  field: 'amount_total',  filter: false,width: 180,cellRenderer: (data) => {
                    let demical = 1
                    if(data.data.licensor.currency == 'krw' ){demical = 0}
                    let t = this.numberFormat(data.value , demical ) + ''+ data.data.licensor.currency.toUpperCase()
                    
                    return `<div class="cellCenter"><span>${t}</span></div>`
                }},
                {headerName: '누적상계금액',  field: 'amount_remaining',  filter: false,width: 180,cellRenderer: (data) => {
                    let demical = 1
                    if(data.data.licensor.currency == 'krw' ){demical = 0}
                    let t = this.numberFormat((data.data.amount_total - data.data.amount_remaining)) + ''+ data.data.licensor.currency.toUpperCase()

                    return `<div class="cellCenter"><span>${t}</span></div>`
                }},
                {headerName: '상계진행률', field: 'amount_remaining', filter: false, width: 160, cellRenderer: (data) => {
                    const total = data.data.amount_total || 0
                    const remaining = data.data.amount_remaining || 0
                    const repaid = total - remaining
                    const pct = total > 0 ? Math.min(100, Math.round((repaid / total) * 100)) : 0
                    const color = pct >= 100 ? '#67c23a' : pct >= 50 ? '#409eff' : '#e6a23c'
                    return `<div style="height:100%;display:flex;align-items:center;padding:0 10px;gap:6px;">
                        <div style="flex:1;background:#e0e0e0;border-radius:4px;height:8px;overflow:hidden;">
                            <div style="background:${color};height:8px;width:${pct}%;border-radius:4px;transition:width 0.3s;"></div>
                        </div>
                        <span style="font-size:11px;white-space:nowrap;min-width:32px;">${pct}%</span>
                    </div>`
                }},
                {headerName: '선급금잔액',  field: 'amount_remaining',  filter: false,width: 180,cellRenderer: (data) => {
                    let demical = 1
                    if(data.data.licensor.currency == 'krw' ){demical = 0}
                    let t = this.numberFormat(data.value , demical ) + ''+ data.data.licensor.currency.toUpperCase()
                    
                    return `<div class="cellCenter"><span>${t}</span></div>`
                }},
                {headerName: '선급정산요율',  field: 'service_fee',  filter: false,width: 110,cellRenderer: (data) => {
                    let t = this.numberFormat(data.value) + '%'
                    
                    return `<div class="cellCenter"><span>${t}</span></div>`
                }},
             
                {headerName: 'Email ID',      field: 'licensor.user.email',     filter: false,width: 300, cellRenderer: (data) => {
                    return `<div class="cellCenter"><span>${data.value}</span></div>`
                }},
                {headerName: '권리자명',      field: 'licensor',     filter: false,width: 200, cellRenderer: (data) => {
                    let name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
                    var pattern3 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; //한글
                    if(pattern3.test(name)){
                        name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
                    }else{
                        name = `${(data.value.given_name ? data.value.given_name : '')} ${(data.value.family_name ? data.value.family_name : '')}` 
                    }
                    return `<div class="cellCenter"><span>${name}</span></div>`
                }},
                {headerName: '회사명',      field: 'licensor.company',     filter: false,width: 200, cellRenderer: (data) => {
                    return `<div class="cellCenter"><span>${data.value ? data.value : ''}</span></div>`
                }},                
                {headerName: '정산화폐',      field: 'licensor.currency',     filter: false,width: 100, cellRenderer: (data) => {
                    return `<div class="cellCenter"><span>${data.value.toUpperCase()}</span></div>`
                }},
                {headerName: '등록일시',      field: 'created_at',     filter: false,width: 200, cellRenderer: (data) => {
                     return `<div class="cellCenter"><span>${this.fixDate(data.value)}</span></div>`
                }},
                // {headerName: '메모',      field: 'description',     filter: false,width: 400, cellRenderer: (data) => {
                //     return `<div class="cellCenter"><span class="text3line">${data.value}</span></div>`
                    
                // }},
            ],
            tableData:[
            ],       
            
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        if(this.$route.query['date_field']) this.dateType = this.$route.query['date_field']
        if(this.$route.query['date_start'] && this.$route.query['date_end'] ) {
            this.startDate = this.$route.query['date_start']
            this.endDate = this.$route.query['date_end']
        }
        if(this.$route.query['hide_finished']) this.hideFinished = this.$route.query['hide_finished'] === 'true'
        
      
    },
    mounted(){
        this.$nextTick(() =>{
        this.callList()
        })
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        resetSearch (){
            this.page.currentPage = 1
            this.keywordType = null
            this.keyword = ''
            this.dateType = null
            this.startDate = null
            this.endDate = null
            this.hideFinished = true
            this.callList()
        },
        callList(){
            const option = {
                sort : 'ref_code',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
            }
            let query = {
                
            }
            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && this.keyword != '') {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword 
            }
           
            
            
            if( !this.valCheck(this.startDate ) && !this.valCheck(this.endDate) ){
                option['date_field'] = this.dateType
                option['date_start'] = this.startDate
                option['date_end'] = this.endDate
                // if(this.dateType !== 'registered_at' ){
                //     option['sort'] = this.dateType +',registered_at'
                // }else{
                //     option['sort'] = this.dateType
                // }

                query['date_field'] = this.dateType
                query['date_start'] = this.startDate
                query['date_end'] = this.endDate
            }else{
                delete option['date_start']
                delete option['date_end']
                delete option['date_field']
                delete query.date_start
                delete query.date_end
                delete query.date_field
            }
            if (this.hideFinished) {
                option['hide_finished'] = true
                query['hide_finished'] = 'true'
            } else {
                delete query.hide_finished
            }
            this.$router.replace({query: query}).catch((e)=>{});
            this.loadingShow()
            this.$store.dispatch('GET_ADVANVEPAYMENT_LIST', option)
            .then(result =>{
                this.loadingHide()
                console.log(result)
                this.tableData  = result.items // 권리자 목록
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
            }).catch(error=>{
                this.loadingHide()
                const status = error.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        list_search(){
            this.page.currentPage = 1  // 초기화
            this.callList()
        },
        viewDetail(event){
            this.$router.push('advancepayment/detail/'+event)
        },

    }
}
</script>

<style scoped>

</style>
